import { __assign } from "tslib";
import { noCase } from "no-case";
export function pascalCaseTransform(input, index) {
  var firstChar = input.charAt(0);
  var lowerChars = input.substr(1).toLowerCase();

  if (index > 0 && firstChar >= "0" && firstChar <= "9") {
    return "_" + firstChar + lowerChars;
  }

  return "" + firstChar.toUpperCase() + lowerChars;
}

if (typeof pascalCaseTransform !== 'undefined' && pascalCaseTransform && pascalCaseTransform === Object(pascalCaseTransform) && Object.isExtensible(pascalCaseTransform) && !pascalCaseTransform.hasOwnProperty('__filemeta')) {
  Object.defineProperty(pascalCaseTransform, '__filemeta', {
    configurable: true,
    value: {
      name: "pascalCaseTransform",
      filename: "node_modules/docz/node_modules/pascal-case/dist.es2015/index.js"
    }
  });
}

export function pascalCaseTransformMerge(input) {
  return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}

if (typeof pascalCaseTransformMerge !== 'undefined' && pascalCaseTransformMerge && pascalCaseTransformMerge === Object(pascalCaseTransformMerge) && Object.isExtensible(pascalCaseTransformMerge) && !pascalCaseTransformMerge.hasOwnProperty('__filemeta')) {
  Object.defineProperty(pascalCaseTransformMerge, '__filemeta', {
    configurable: true,
    value: {
      name: "pascalCaseTransformMerge",
      filename: "node_modules/docz/node_modules/pascal-case/dist.es2015/index.js"
    }
  });
}

export function pascalCase(input, options) {
  if (options === void 0) {
    options = {};
  }

  return noCase(input, __assign({
    delimiter: "",
    transform: pascalCaseTransform
  }, options));
}

if (typeof pascalCase !== 'undefined' && pascalCase && pascalCase === Object(pascalCase) && Object.isExtensible(pascalCase) && !pascalCase.hasOwnProperty('__filemeta')) {
  Object.defineProperty(pascalCase, '__filemeta', {
    configurable: true,
    value: {
      name: "pascalCase",
      filename: "node_modules/docz/node_modules/pascal-case/dist.es2015/index.js"
    }
  });
}